export const fontSize = {
  Nano: "0.75rem",
  XXXS: "0.875rem",
  XXS: "1rem",
  XS: "1.125rem",
  SM: "1.25rem",
  MD: "1.5rem",
  LG: "2rem",
  XL: "2.5rem",
} as const;
